import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController } from 'ionic-angular';
import { Service } from '../../app/service';
import { QrCode } from '../qrcode/qrcode';
import { BarcodeScanner } from 'ionic-native';

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
  //providers: [Service]
})

export class Settings {

  settingsGUI: any;
  settings: any;
  qrcode: any;
  isBrowser: any;

  constructor(public navCtrl: NavController, private navParams: NavParams, private DataProvider: Service) {
    console.log("settings");

    //hide qr in browser
    this.isBrowser = DataProvider.isBrowserPlatform();
    //Get text and Bsp
    this.settingsGUI = DataProvider.getSettingsText();

    //get storage data
    var data = this.DataProvider.getSettingsData();
    console.log("settings loaded: ", data);
    for(var i=0; i<data.length; i++)
      this.settingsGUI[i].value = data[i];
  }

  ionViewWillLeave() {
    this.writeSettings();
  }

  writeSettings()
  {
    this.DataProvider.setSettingsData(this.settingsGUI);
    console.log("values set:", this.settingsGUI);
  }

  showQrCode() {
    this.writeSettings();

    this.settings = this.DataProvider.getSettingsData();
    console.log("settings", this.settings);

    //check for all answers
    var notAllAnswers = false;
    for(var i=0; i<this.settings.length; i++)
    {
      if(this.settings[i] == null || this.settings[i].length <= 0)
      {
        notAllAnswers = true;
      }
    }

    if(!notAllAnswers)
    {

      var _tempQr = this.settings[0];

      for(var i=1; i<this.settings.length; i++)
      {
        _tempQr += "#"+this.settings[i];
      }

      this.qrcode = "http://www.feuerwehr-innovativ.at?wt=" + this.DataProvider.encryptText(_tempQr.toString(), "wt16");
      if(!this.isBrowser)
      {
        BarcodeScanner.encode(BarcodeScanner.Encode.TEXT_TYPE, this.qrcode).then((succ) => {
          console.log("qr code", succ);
        }, (err) => {
          console.log("qr code error", err);
        });
      }
      else
      {
        this.navCtrl.push(QrCode, {qrdata: this.qrcode});
      }
    }
    else
    {
      //not all answers set
      this.DataProvider.showPopup("Einstellungen", "Bitte in den Einstellungen alle Antworten einsetzen!", "Ok", "Abbrechen", this, function(ref, button){
          if(!button)  //clicked open settings
            ref.NavPop();
      })
    }
  }

  NavPop() {
    this.navCtrl.pop();
  };

  scanQrCode() {
    BarcodeScanner.scan().then((barcodeData) => {
      var baseParts = [];
      var fields = [];
      var QrData = "";

      console.log("qr code", barcodeData);

      if(!barcodeData.cancelled)
      {
        QrData = barcodeData.text;

        baseParts = QrData.split('http://www.feuerwehr-innovativ.at?wt=');
        console.log("base parts", baseParts);
        if(baseParts.length >= 2)
        {
          baseParts[1] = this.DataProvider.decryptText(baseParts[1], "wt16").toString();
          fields = baseParts[1].split('#');
          console.log("fields", fields);

          if(fields.length == this.settingsGUI.length)  //read ok
          {
            for(var i=0; i<this.settingsGUI.length; i++)
              this.settingsGUI[i].value = fields[i];
          }
          else
          {
            this.DataProvider.showPopup("Fehler", "Fehler beim Lesen des QR Codes. Erneut versuchen?", "Ok", "Abbrechen", this, function(ref, button){
                if(button)  //clicked open settings
                  ref.scanQrCode();
            });
          }
        }
        else
        {
          this.DataProvider.showPopup("Fehler", "Fehler beim Lesen des QR Codes. Erneut versuchen?", "Ok", "Abbrechen", this, function(ref, button){
              if(button)  //clicked open settings
                ref.scanQrCode();
          });
        }
      }

    }, (err) => {
      // An error occurred
      console.log("qr code error", err);
      this.DataProvider.showPopup("Fehler", "Fehler beim Lesen des QR Codes. Erneut versuchen?", "Ok", "Abbrechen", this, function(ref, button){
          if(button)  //clicked open settings
            ref.scanQrCode();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts